import { isSet } from "../helpers/isset";

/**
 * Description: Initialise the inline search feilds
 * 
 * @class InlineSearch
 * @typedef {InlineSearch}
 */

class InlineSearch {
    constructor (domNode) {
        this.domNode = domNode;
        this.previousSearchString = '';
        this.doesClearButtonExist = false;
        this.timeout = 0;

        window.addEventListener(
            'load',
            this.init.bind(this),
            true
        );
    }

    init(){
        this.fieldContainer = this.domNode.querySelector('.field-inner');
        if(!isSet(this.fieldContainer)){
            console.warn("Element .field-inner does exist in the domNode");
            return;
        }

        this.submitButton = this.fieldContainer.querySelector('button');
        if(!isSet(this.submitButton)){
            console.warn("Search submit button does exist in .field-inner");
            return;
        }

        this.searchInput = this.fieldContainer.querySelector('input');
        if(!isSet(this.searchInput)){
            console.warn("Search input does exist in .field-inner");
            return;
        }

        this.searchInput.addEventListener(
            'keyup',
            this.onSearchInputKeyup.bind(this),
            false
        );
    }

    /**
     * Checks if the passed string is different when compared with the previously stored search string this.previousSearchString
     * @param  {String}  value  The search query string that we want to check that has changed
     */
    hasChanged(value){
        if(value == this.previousSearchString){
            return false;
        }

        return true;
    }

    buildClearButton(){
        const clearButton = document.createElement('button');
        clearButton.classList.add('clear-search', 'block-button', 'square', 'secondary');
        clearButton.setAttribute('type', 'button');
        clearButton.addEventListener(
            'click',
            this.onClearButtonClick.bind(this),
            false
        );

        const span = document.createElement('span');
        span.textContent = "Clear Search";
        span.classList.add("is-visually-hidden");

        const icon = document.createElement('i');
        icon.classList.add('sa-icon--close');

        clearButton.append(span);
        clearButton.append(icon);

        return clearButton;
    }

    onSearchInputKeyup(e){
        if(!this.hasChanged(this.searchInput.value)){
            return;
        }

        this.previousSearchString = this.searchInput.value;
        const submitButton = this.submitButton;
        this.clearButton = this.buildClearButton();

        const key = e.key;
        let flag = false;

        if(this.searchInput.value.length == 0){
            this.domNode.querySelector('.clear-search').remove();
            this.doesClearButtonExist = false;
            submitButton.click();
        }

        switch (key) {
            case 'Enter':
                submitButton.click();
                flag = true;
                break;
            case 'Tab':
                flag = false;
                break;
            default:
                clearTimeout(this.timeout);
                this.timeout = setTimeout(
                    function(){
                        submitButton.click();
                    },
                    750
                );
                break;
        }

        if(this.searchInput.value.length >= 1){
            if(this.doesClearButtonExist === false){
                this.fieldContainer.append(this.clearButton);
                this.doesClearButtonExist = true;
            }
        }

        if (flag) {
            e.stopPropagation();
            e.preventDefault();
        }
    }

    onClearButtonClick(e){
        this.searchInput.value = "";
        this.submitButton.click();
        e.currentTarget.remove();
        this.doesClearButtonExist = false;
    }
}

exports.InlineSearch = InlineSearch;